import { ArrowBackOutlined, ArrowForwardOutlined, ChangeCircleOutlined, DeleteOutlined, EditOutlined } from "@mui/icons-material";
import { IconButton, ThemeProvider, Tooltip } from "@mui/material";
import { useState } from "react";
import theme from "../../style/theme";
import { useTranslation } from "react-i18next";

export default function ImageEditable({id, src, alt, onChange=(url)=>{}, canEdit=true}) {
    const [hover, setHover] = useState(false);

    return <div style={{position:'relative'}}>
        <img id={id} src={src} alt={alt} className={canEdit?"editable-image":''}/>
        {canEdit
            ? <>
                <div className='editable-image-overlay' onMouseEnter={() => {setHover(true)}} onMouseLeave={() => {setHover(false)}} onClick={() => {
                    document.getElementById(`input-picker-${id}`).click();
                }}>
                    <div className={`icon-overlay ${hover ? 'hover' : ''}`}>
                        <EditOutlined/>
                    </div>
                </div>
                <input 
                    id={`input-picker-${id}`}
                    type="file"
                    style={{display:'none'}}
                    accept="image/webp"
                    onChange={(e) => {
                        document.getElementById(id).src = URL.createObjectURL(e.target.files[0]);
                        onChange(document.getElementById(id).src);
                    }}
                />
            </> : null
        }
    </div>
}

export function ChangeDeleteImage({ id, src, alt, onChange=(url)=>{}, onDelete=()=>{}, onMoveRight=()=>{}, onMoveLeft=()=>{}, canEdit=true, canMoveLeft=false, canMoveRight=false }) {
    const { t } = useTranslation();

    return <div style={{position:'relative'}}>
        <img id={id} src={src} alt={alt}/>
        {canEdit
            ? <ThemeProvider theme={theme}>
                <div style={{
                    position:'absolute',
                    top: 0,
                    right: -1,
                    
                    display:'flex',
                    flexFlow: 'row-reverse',

                    background: 'white',
                    borderRadius: '0 15px 0 0',
                }}>
                    <Tooltip title={t('actions.delete')}><IconButton onClick={onDelete}><DeleteOutlined/></IconButton></Tooltip>
                    <Tooltip title={t('actions.change')}><IconButton onClick={()=>{
                        document.getElementById(`input-picker-${id}`).click();
                    }}><ChangeCircleOutlined/></IconButton></Tooltip>
                    <Tooltip title={t('actions.moveRight')}><IconButton onClick={canMoveRight ? onMoveRight : null} disabled={!canMoveRight}><ArrowForwardOutlined/></IconButton></Tooltip>
                    <Tooltip title={t('actions.moveLeft')}><IconButton onClick={canMoveLeft ? onMoveLeft : null} disabled={!canMoveLeft}><ArrowBackOutlined/></IconButton></Tooltip>
                </div>
            </ThemeProvider> : null
        }
        {canEdit
            ? <input 
                id={`input-picker-${id}`}
                type="file"
                style={{display:'none'}}
                accept="image/webp"
                onChange={(e) => {
                    document.getElementById(id).src = URL.createObjectURL(e.target.files[0]);
                    onChange(document.getElementById(id).src);
                }}
            /> : null
        }
    </div>
}